import React from 'react'
import {
  Filter,
  FilterComponent,
  FilterOption
} from '../../components/_WMS/FilterComponent'

export const filterOptions: FilterOption[] = [
  {
    order: 1,
    key: 'workOrderId',
    label: 'OT',
    type: 'numeric'
  },
  {
    order: 2,
    key: 'trackingNumber',
    label: 'Tracking Number',
    type: 'text'
  },
  {
    order: 3,
    key: 'courierId',
    label: 'Courier',
    type: 'precreated'
  },
  {
    order: 4,
    key: 'externalOrderId',
    label: 'ID de Pedido',
    type: 'text'
  }
]

interface SearchProps {
  onSearchClick: (filters: Filter[]) => void
  selectedFilters: Filter[]
  setSelectedFilters: any
  includeAddButton?: boolean
  defaultSelectedFilterKey?: string
}

export const SearchReturnFilters: React.FC<SearchProps> = (props) => {
  return <FilterComponent options={filterOptions} {...props} />
}
